module.exports = __webpack_public_path__ + "static/media/revision-large@2x.f8554836.png";